import React from "react";
import "../../Styles/certified/aziro.css";

export default function Aziro() {
  return (
    <>
      <div className="aziro-certified-details-section">
        <div className="aziro-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="aziro-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="aziro-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="aziro-certified-badge"
            />
            <div className="aziro-certified-company-names">
              <a href="https://www.aziro.com" target="_blank" rel="noopener noreferrer">
                <img src="https://www.aziro.com/_next/image?url=https%3A%2F%2Fcdn.aziro.com%2Fmedia%2Faziro_logo_ec87b0962d.png&w=256&q=75" alt="Aziro Logo" className="aziro-certified-company-logo" />
              </a>
              <h1 className="aziro-certified-full-name">
                Aziro (Formerly MSys Tech India Private Limited)
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="aziro-certified-details-right">
            <img
              src="/assets/aziro/right.jpeg"
              alt="Aziro Office"
              className="aziro-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="aziro-certified-description">
          <h2>
            Why Aziro (Formerly MSys) is a Outstanding Workplaces
          </h2>
          <p>
            Aziro (formerly MSys Technologies and pronounced as "Ah-zee-roh") is an Al-native product engineering company driving innovation-led tech transformation for Fortune 500 and Global 2000 Enterprises and ISV’s.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="aziro-certified-info-cards">
          <div className="aziro-certified-info-card">
            <div className="aziro-certified-info-title">COMPANY SIZE</div>
            <div className="aziro-certified-info-value">1400 Employees</div>
          </div>
          <div className="aziro-certified-info-card">
            <div className="aziro-certified-info-title">INDUSTRY</div>
            <div className="aziro-certified-info-value">Information Technology</div>
          </div>
          <div className="aziro-certified-info-card">
            <div className="aziro-certified-info-title">CONNECT</div>
            <div className="aziro-certified-info-icons">
              <span className="aziro-certified-icon-round">
                <a href="https://www.aziro.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="aziro-certified-icon-round">
                <a href="https://www.linkedin.com/company/azirotech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="aziro-certified-icon-round">
                <a href="https://www.facebook.com/AziroTech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="aziro-certified-icon-round">
                <a href="https://www.instagram.com/azirotech?igsh=MTYyYno1em5xcTZqNw==" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="aziro-certified-icon-round">
                <a href="https://x.com/AziroTech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="aziro-certified-info-card">
            <div className="aziro-certified-info-title">LOCATION (HQ)</div>
            <div className="aziro-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="aziro-certified-recognition-section">
          <h2 className="aziro-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="aziro-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="aziro-certified-recognition-image"
            />
          </div>
          <div className="aziro-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Aziro Section */}
        <div className="aziro-certified-life-section">
          <h2 className="aziro-certified-life-title">
            Life at Aziro (Formerly MSys Tech India Private Limited)
          </h2>
          <div className="aziro-certified-life-gallery">
            <div className="aziro-certified-life-col">
              <img src="/assets/aziro/office1.jpeg" alt="Office 1" className="aziro-certified-life-img" />
              <img src="/assets/aziro/meeting1.jpeg" alt="Meeting 1" className="aziro-certified-life-img" />
            </div>
            <div className="aziro-certified-life-col aziro-certified-life-center">
              <img src="/assets/aziro/main.jpeg" alt="Main Office" className="aziro-certified-life-img aziro-certified-life-img-large" />
            </div>
            <div className="aziro-certified-life-col">
              <img src="/assets/aziro/office2.jpeg" alt="Office 2" className="aziro-certified-life-img" />
              <img src="/assets/aziro/meeting2.jpeg" alt="Meeting 2" className="aziro-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}